import { axiosApi } from "@/config/axios.config";
import { useMutation } from "@tanstack/react-query";
import { AxiosResponse } from "axios";

export default function useUploader(projectKey: string) {
  const { mutateAsync, isPending } = useMutation({
    mutationFn: async (
      formdata: React.ChangeEvent<HTMLInputElement> | File
    ) => {
      let ImgFile: File; //이미지 파일

      if (formdata instanceof File) {
        ImgFile = formdata;
      } else if (
        formdata.target &&
        formdata.target.files &&
        formdata.target.files.length > 0
      ) {
        ImgFile = formdata.target.files[0];
      } else {
        throw new Error("파일이 존재하지 않습니다.");
      }

      if (!ImgFile) throw new Error("파일이 존재하지 않습니다.");

      const imgSize = ImgFile.size / 1024 / 1024;

      if (parseInt(imgSize.toFixed(2)) > 10) {
        throw new Error(`${imgSize} 파일은  10mb이하만 가능합니다. `);
      }
      if (!ImgFile.type.startsWith("image/")) {
        throw new Error("이미지 파일만 업로드 가능합니다.");
      }

      const fileName = ImgFile.name.replace(/[^\w.-]/g, "_");
      const imgKey = projectKey;
      const fileType = ImgFile.type;

      const response: AxiosResponse<{
        url: string;
        key: string;
      }> = await axiosApi.post(`/upload`, {
        fileName,
        fileType,
        imgKey,
      });

      const { url, key } = response.data;

      await fetch(url, {
        method: "PUT",
        headers: {
          "Content-Type": fileType,
        },
        body: ImgFile,
      });

      return key as string; //경로임
    },
  });

  return { mutateAsync, isPending };
}
